import Layout from "components/layout";
import VideoTranslation from "components/reusableComponents/VideoTransFolder/VideoTranslation";
import SEO from "components/seo";
import React from "react";

function index() {
  const title = "Video Translation and Transcription Service | Tomedes";
  const description = "";
  const keywords = "";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/video-translation"
      />
      <VideoTranslation />
    </Layout>
  );
}

export default index;
